export const extractAccessories = (arg) => {
  const { accessories, accessoriesInfoList } = arg;
  if (!accessories || accessories.length === 0) return {};

  const reductor = (acc, accessory) => {
    const accessoryQuantity = accessory.quantity || 1;
    const selectedVariant = accessoriesInfoList.find((info) => info.id === accessory.product_id).selected_variant;
    return acc + (selectedVariant.price * accessoryQuantity);
  };

  return {
    selected: true,
    subTotal: accessories.reduce(reductor, 0),
  };
};
